import React from 'react';
import './Advisors.css';
import siteConfig from '../../configuration/siteConfiguration';

const baseImageUrl = `${siteConfig.assetBaseUrl}/icons/verticals-we-power/default`;

const advisorData = [
  {
    title: "Legal & Judiciary",
    description: "Senior advocates, retired High Court judges, and legal scholars from Supreme Court Bar and NALSAR contribute to the evolution of CIP-Legal, ensuring jurisprudential integrity, courtroom relevance, and regulatory alignment.",
    icon: `${baseImageUrl}/Legal.svg`
  },
  {
    title: "Healthcare & Compliance",
    description: "Advisors from NABH-accredited hospitals, public health systems, and clinical governance boards help shape CIP-Healthcare's consent lifecycle, documentation compliance, and patient safety intelligence.",
    icon: `${baseImageUrl}/Healthcare.svg`
  },
  {
    title: "Global Policy & ESG & Energy",
    description: "Experts from global compliance boards and ESG & Energy frameworks (SFDR, BRSR, GRI) support our ESG & Energy intelligence Copilot and compliance dashboards to ensure traceability and auditability.",
    icon: `${baseImageUrl}/ESG.svg`
  },
  {
    title: "Academic & Technical Institutions",
    description: "Advisors from IITs, IIMs, and public think tanks provide strategic counsel on LLM optimization, policy modeling, and AI adoption across regulated sectors.",
    icon: `${baseImageUrl}/Regulations.svg`
  }
];

const AdvisorCard = ({ icon, title, description }) => {
  return (
    <div className="advisor-card">
      <img src={icon} alt="Advisor Icon" className="advisor-icon" />
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
};

const Advisors = () => {
  return (
    <>
      <section className="advisors-section">
        <div className="advisors-main-content">
          <div className="advisors-text-content">
            <h3>— ADVISORS</h3>
            <h2>Our backbone</h2>
            <p>
              Cognitva is backed by a trusted circle of domain leaders and
              regulatory experts who guide our platform strategy, vertical
              alignment, and go-to-market execution.
            </p>
          </div>
          <div className="advisors-cards-container">
            {advisorData.map((advisor, index) => (
              <AdvisorCard icon={advisor.icon} key={index} title={advisor.title} description={advisor.description} />
            ))}
          </div>
        </div>

      </section>
      <div className="advisors-divider"></div>
    </>
  );
};

export default Advisors; 